import { Grid } from '@material-ui/core'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import { ButtonHLPure, HeaderHLPure } from '../../../pures'
import { useTranslation } from 'react-i18next'
import InputPureWrapper from './inputs/inputPureWrapper'
import TextAreaWrapper from './inputs/textareaWrapper'
import { RegistrationValidator } from '../../../../validators'
import { LocalStorageService } from '../../../../services'

const localStorageService = new LocalStorageService()

let token = localStorageService.getLocalStorageItem('token')
if (token) token = token.idToken

function CompanyDataForm(props) {
  const {
    moveStep,
    onSubmitStep
  } = props

  const { t } = useTranslation()
  const { t: tCommon } = useTranslation('common')
  const validator = RegistrationValidator(t)

  return (
    <Form
      onSubmit={onSubmitStep}
      render={(formRenderProps) => {
        return (
          <FormElement>
            <Grid container className='companyDataForm' spacing={3}>
              <Grid item xs={12}>
                <HeaderHLPure title={t('registration.action.companyInformation')} headingNumber={2} />
              </Grid>
              <Grid item xs={12}>
                <Field
                  id='name'
                  name={'name'}
                  component={InputPureWrapper}
                  label={`${t('register.invoiceData.name')} *`}
                  validator={validator.requiredValidator}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  id='description'
                  name={'description'}
                  component={TextAreaWrapper}
                  label={`${t('register.companyData.activityDescription')}`}
                  // validator={validator.requiredValidator}
                />
              </Grid>
              <Grid item xs={12} className='onboardingView-actions'>
                <ButtonHLPure colorScheme='error' outlined nameBtn={tCommon('back')} onClick={() => moveStep(false)} />
                <ButtonHLPure type='submit' colorScheme='primary' outlined nameBtn={tCommon('continue')} />
              </Grid>
            </Grid>
          </FormElement>
        )
      }}
    />
  )
}

export default CompanyDataForm